const initialState = {
  user: null, // Will hold the full user object (name, email, etc.)
  isLoggedIn: false,
  loading: false,
  error: null
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'AUTH_REQUEST':
      return {
        ...state,
        loading: true,
        error: null
      };

    case 'LOGIN_SUCCESS':
    case 'REGISTER_SUCCESS':
      return {
        ...state,
        user: action.payload, // API response data
        isLoggedIn: true,
        loading: false
      };

    case 'SAVE_PROFILE':
      return { ...state, user: action.payload, loading: false };

    case 'AUTH_FAILURE':
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    case 'LOGOUT':
      return {
        ...state,
        user: null,
        isLoggedIn: false,
        loading: false
      };

    default:
      return state;
  }
};

export default authReducer;
